import { useEffect } from 'react';
import { useSiteConfig } from '../context/SiteConfigContext';
import { SITE_URL, SITE_NAME } from '../utils/seo';

/**
 * Injecte les schémas Organization + WebSite (schema.org) une seule fois,
 * indépendamment de la page affichée — contrairement à Seo.jsx qui gère les
 * balises propres à chaque route (title, description, JSON-LD de page...).
 */
export default function SiteJsonLd() {
  const { config } = useSiteConfig();

  useEffect(() => {
    const sameAs = [config.facebook, config.instagram, config.linkedin, config.tiktok, config.youtube].filter(Boolean);

    const data = [
      {
        '@context': 'https://schema.org',
        '@type': 'NGO',
        name: config.siteName || SITE_NAME,
        url: SITE_URL,
        logo: `${SITE_URL}/logo-horizontal-color.png`,
        description: config.tagline,
        email: config.email,
        telephone: config.phone,
        address: config.adresse ? {
          '@type': 'PostalAddress',
          streetAddress: config.adresse,
          addressLocality: 'Dakar',
          addressCountry: 'SN',
        } : undefined,
        sameAs: sameAs.length ? sameAs : undefined,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: config.siteName || SITE_NAME,
        url: SITE_URL,
      },
    ];

    let el = document.head.querySelector('script#site-jsonld');
    if (!el) {
      el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = 'site-jsonld';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  }, [config]);

  return null;
}
